// extracted by mini-css-extract-plugin
export default {"accountBox":"components_accountBox__+6L9P","account":"components_account__SbMJk","used":"components_used__Wdphd"};